import moment from 'moment-timezone';

export const CLASS_PREFERENCE_OPTIONS = [
  { value: 'CHOICE', label: 'Choice' },
  { value: 'GC', label: 'Group classes' },
  { value: '1on1', label: '1on1' }
];

// Numbers are kept as strings while editing so a half-typed value ("12.") is not
// coerced away under the cursor; to_payload parses them once on submit.
export const EMPTY_FORM = {
  name: '',
  description: '',
  credits: '0',
  expiry_from_activation: '0',
  offer_expiry: '',
  package_uuid: '',
  percentage_discount: '0',
  fixed_discount: '0',
  funnel_url: '',
  funnel_type: '',
  offer_type: '',
  lp_version: '',
  class_preference: 'CHOICE'
};

// <input type="datetime-local"> holds a zoneless wall clock. It is read and
// written in the zone picked in the Hridaya header (state.home.iana_timezone),
// not the browser's, because every other Hridaya page shows times in that zone
// (coupons/index.jsx formats with .tz(iana_timezone)); an ops user in IST with
// the header on Pacific would otherwise enter an IST expiry on a page whose
// header says Pacific. goserver stores offer_expiry as UTC, so the wire always
// carries an ISO instant with Z.
export const LOCAL_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm';

export const from_affiliate = (row, tz) => ({
  name: row.name || '',
  description: row.description || '',
  credits: String(row.credits ?? 0),
  expiry_from_activation: String(row.expiry_from_activation ?? 0),
  offer_expiry: row.offer_expiry ? moment(row.offer_expiry).tz(tz).format(LOCAL_INPUT_FORMAT) : '',
  package_uuid: row.package_uuid || '',
  percentage_discount: String(row.percentage_discount ?? 0),
  fixed_discount: String(row.fixed_discount ?? 0),
  funnel_url: row.funnel_url || '',
  funnel_type: row.funnel_type || '',
  offer_type: row.offer_type || '',
  lp_version: row.lp_version || '',
  class_preference: row.class_preference || 'CHOICE'
});

const INTEGER_FIELDS = ['expiry_from_activation', 'percentage_discount', 'fixed_discount'];

// Returns { payload } or { error }. Range checks stay on the server, which owns
// them; this only catches what JSON cannot carry (a non-number) and the one
// required field, so the user is told before a round trip.
export const to_payload = (form, tz) => {
  if (!form.name.trim()) return { error: 'Name is required.' };

  // Number('') is 0, so an emptied box would otherwise be sent as a silent zero.
  const credits = Number(form.credits);
  if (form.credits === '' || Number.isNaN(credits)) return { error: 'Credits must be a number.' };
  const bad_integer = INTEGER_FIELDS.find(
    (field) => form[field] === '' || !Number.isInteger(Number(form[field]))
  );
  if (bad_integer) return { error: `${bad_integer.replace(/_/g, ' ')} must be a whole number.` };

  return {
    payload: {
      ...form,
      credits,
      expiry_from_activation: Number(form.expiry_from_activation),
      percentage_discount: Number(form.percentage_discount),
      fixed_discount: Number(form.fixed_discount),
      offer_expiry: form.offer_expiry
        ? moment.tz(form.offer_expiry, LOCAL_INPUT_FORMAT, tz).toISOString()
        : null
    }
  };
};
